/**
 * Created by Allan on 2021/05/17.
 * Contact 84880528@qq.com.
 */
import Frame from '@/layouts/Frame'
export default[
    {
        path:'/risk',
        meta:{
            title:'风控报表',
            icon:'el-icon-s-marketing',
            menuId:'21'
        },
        component:Frame,
        children:[
            {
                path:'income',
                name:'riskIncome',
                meta:{
                    title:'风控进件报表',
                    menuId:'22'
                },
                component:resolve => require(['@/views/risk/income/index'], resolve)
            },
            {
                path:'afterloan',
                name:'riskAfterloan',
                meta:{
                    title:'风控贷后报表',
                    menuId:'23'
                },
                component:resolve => require(['@/views/risk/afterloan/index'], resolve)
            },
            {
                path:'sum',
                name:'riskSum',
                meta:{
                    title:'结清监控',
                    menuId:'29'
                },
                component:resolve => require(['@/views/risk/sum/index'], resolve)
            },
            {
                path:'grade',
                name:'riskGrade',
                meta:{
                    title:'模型分数监控',
                    menuId:'28'
                },
                component:resolve => require(['@/views/risk/grade/index'], resolve)
            },
            {
                path:'accuracy',
                name:'riskAccuracy',
                meta:{
                    title:'规则命中率监控',
                    menuId:'30'
                },
                component:resolve => require(['@/views/risk/accuracy/index'], resolve)
            },
            {
                path:'output',
                name:'riskOutput',
                meta:{
                    title:'风控输出分布',
                    menuId:'56'
                },
                component:resolve => require(['@/views/risk/output/index'], resolve)
            },
        ],
    }
]



// WEBPACK FOOTER //
// ./src/router/map/risk.js